import { render, staticRenderFns } from "./CostManual.vue?vue&type=template&id=624498c1"
import script from "./CostManual.vue?vue&type=script&lang=js"
export * from "./CostManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports